export default {
  headers: [
    {
      id: 'main-header',
      logo: {
        alt: 'logo',
        src: 'https://si-homelight.s3.amazonaws.com/sites/cres/logo.png',
        url: 'https://www.livelovesandiegohomes.com/',
      },
      breakpoint: 1460,
      desktopMenu: {
        type: 'default',
        disableOnHoverMenuExpand: false,
        logo: {
          show: true,
          reverseOrder: false,
          containerClassName: 'on-cres-desktop-header-logo-container',
          imageClassName: 'on-cres-desktop-header-logo',
        },
        headerClassName: 'on-cres-desktop-header',
        headerSectionsClassName: 'on-cres-desktop-header-sections',
        headerClassNameOverride: '',
        headerSectionsClassNameOverride: '' || null,
        itemClassName: 'on-cres-desktop-item',
        menuClassName: 'on-cres-desktop-menu',
        menuLabelActiveClassName: '',
        menuItemClassName: 'on-cres-desktop-item-folder',
        subMenuClassName: '',
        subMenuLabelActiveClassName: '',
        subMenuItemClassName: '',
        items: [
          {
            id: 'buy-item',
            content: 'BUY',
            url: 'https://search.livelovesandiegohomes.com/',
          },
          {
            id: 'sell-item',
            content: 'SELL',
            menuItems: [
              {
                id: 'sell-item-home-val',
                url: 'https://www.livelovesandiegohomes.com/home-valuation',
                content: 'HOME VALUATION',
              },
              {
                id: 'sell-item-why-with-us',
                url: 'https://www.livelovesandiegohomes.com/why-list-with-us',
                content: 'WHY LIST WITH US',
              },
            ],
          },
          {
            id: 'trade-in-item',
            url: 'https://www.livelovesandiegohomes.com/trade-in',
            content: 'TRADE-IN',
          },
          {
            id: 'communities-item',
            content: 'COMMUNITIES',
            menuItems: [
              {
                id: 'communities-item-all',
                url: 'https://www.livelovesandiegohomes.com/communities',
                content: 'ALL COMMUNITIES',
              },
              {
                id: 'communities-item-encinitas',
                url: 'https://www.livelovesandiegohomes.com/communities/encinitas-real-estate',
                content: 'ENCINITAS',
              },
              {
                id: 'communities-item-carlsbad',
                url: 'https://www.livelovesandiegohomes.com/communities/carlsbad-real-estate',
                content: 'CARLSBAD',
              },
              {
                id: 'communities-item-del-mar',
                url: 'https://www.livelovesandiegohomes.com/communities/del-mar-real-estate',
                content: 'DEL MAR',
              },
              {
                id: 'communities-item-poway',
                url: 'https://www.livelovesandiegohomes.com/communities/poway-real-estate',
                content: 'POWAY',
              },
              {
                id: 'communities-item-rancho',
                url: 'https://www.livelovesandiegohomes.com/communities/rancho-santa-fe-real-estate',
                content: 'RANCHO SANTA FE',
              },
              {
                id: 'communities-item-san-diego',
                url: 'https://www.livelovesandiegohomes.com/communities/san-diego-real-estate',
                content: 'SAN DIEGO',
              },
              {
                id: 'communities-item-solana',
                url: 'https://www.livelovesandiegohomes.com/communities/solana-beach-real-estate',
                content: 'SOLANA BEACH',
              },
              {
                id: 'communities-item-carmel',
                url: 'https://www.livelovesandiegohomes.com/communities/carmel-valley-real-estate',
                content: 'CARMEL VALLEY',
              },
              {
                id: 'communities-item-cardiff',
                url: 'https://www.livelovesandiegohomes.com/communities/cardiff-real-estate',
                content: 'CARDIFF',
              },
              {
                id: 'communities-item-clairemont',
                url: 'https://www.livelovesandiegohomes.com/communities/clairemont-real-estate',
                content: 'CLAIREMONT',
              },
              {
                id: 'communities-item-pacific',
                url: 'https://www.livelovesandiegohomes.com/communities/pacific-beach-real-estate',
                content: 'PACIFIC BEACH',
              },
              {
                id: 'communities-item-university',
                url: 'https://www.livelovesandiegohomes.com/communities/university-city-real-estate',
                content: 'UNIVERSITY CITY',
              },
              {
                id: 'communities-item-la-jolla',
                url: 'https://www.livelovesandiegohomes.com/communities/la-jolla-real-estate',
                content: 'LA JOLLA',
              },
            ],
          },
          {
            id: 'financing-item',
            url: 'https://www.livelovesandiegohomes.com/financing',
            content: 'FINANCING',
          },
          {
            id: 'testimonials-item',
            url: 'https://www.livelovesandiegohomes.com/testimonials',
            content: 'TESTIMONIALS',
          },
          {
            id: 'teams-item',
            content: 'TEAMS',
            menuItems: [
              {
                id: 'teams-item-sales',
                url: 'https://www.livelovesandiegohomes.com/sales-team',
                content: 'SALES TEAM',
              },
              {
                id: 'teams-item-back-office',
                url: 'https://www.livelovesandiegohomes.com/back-office-team',
                content: 'BACK OFFICE TEAM',
              },
              {
                id: 'teams-item-brokerage',
                url: 'https://www.livelovesandiegohomes.com/brokerage-agents',
                content: 'BROKERAGE AGENTS',
              },
            ],
          },
          {
            id: 'contact-us-item',
            url: 'https://www.livelovesandiegohomes.com/new-contact-us',
            content: 'CONTACT US',
          },
          {
            id: 'blog-item',
            url: 'https://www.livelovesandiegohomes.com/blog',
            content: 'BLOG',
          },
          {
            id: 'home-item',
            url: 'https://www.livelovesandiegohomes.com/',
            content: 'HOME',
            className: 'on-cres-desktop-special-item',
          },
        ],
      },
      mobileMenu: {
        logo: {
          show: true,
          containerClassName: 'on-cres-mobile-header-logo-container',
          imageClassName: 'on-cres-mobile-header-logo',
        },
        type: 'mobile-default',
        menuOpener: {
          className: 'on-test',
          content: 'Open',
        },
        headerClassName: 'on-cres-mobile-header',
        headerClassNameOverride: '',
        mobileMenuClassName: 'on-cres-mobile-menu',
        menuClassName: 'on-cres-mobile-folder',
        itemClassName: 'on-cres-mobile-item',
        menuLabelActiveClassName: 'on-cres-mobile-folder-active',
        menuItemClassName: 'on-cres-mobile-item-folder',
        subMenuClassName: '',
        subMenuItemClassName: '',
        headerItems: [],
        items: [
          {
            id: 'buy-item',
            content: 'BUY',
            url: 'https://search.livelovesandiegohomes.com/',
          },
          {
            id: 'sell-item',
            content: 'SELL',
            menuItems: [
              {
                id: 'sell-item-home-val',
                url: 'https://www.livelovesandiegohomes.com/home-valuation',
                content: 'HOME VALUATION',
              },
              {
                id: 'sell-item-why-with-us',
                url: 'https://www.livelovesandiegohomes.com/why-list-with-us',
                content: 'WHY LIST WITH US',
              },
            ],
          },
          {
            id: 'trade-in-item',
            url: 'https://www.livelovesandiegohomes.com/trade-in',
            content: 'TRADE-IN',
          },
          {
            id: 'communities-item',
            content: 'COMMUNITIES',
            menuItems: [
              {
                id: 'communities-item-all',
                url: 'https://www.livelovesandiegohomes.com/communities',
                content: 'ALL COMMUNITIES',
              },
              {
                id: 'communities-item-encinitas',
                url: 'https://www.livelovesandiegohomes.com/communities/encinitas-real-estate',
                content: 'ENCINITAS',
              },
              {
                id: 'communities-item-carlsbad',
                url: 'https://www.livelovesandiegohomes.com/communities/carlsbad-real-estate',
                content: 'CARLSBAD',
              },
              {
                id: 'communities-item-del-mar',
                url: 'https://www.livelovesandiegohomes.com/communities/del-mar-real-estate',
                content: 'DEL MAR',
              },
              {
                id: 'communities-item-poway',
                url: 'https://www.livelovesandiegohomes.com/communities/poway-real-estate',
                content: 'POWAY',
              },
              {
                id: 'communities-item-rancho',
                url: 'https://www.livelovesandiegohomes.com/communities/rancho-santa-fe-real-estate',
                content: 'RANCHO SANTA FE',
              },
              {
                id: 'communities-item-san-diego',
                url: 'https://www.livelovesandiegohomes.com/communities/san-diego-real-estate',
                content: 'SAN DIEGO',
              },
              {
                id: 'communities-item-solana',
                url: 'https://www.livelovesandiegohomes.com/communities/solana-beach-real-estate',
                content: 'SOLANA BEACH',
              },
              {
                id: 'communities-item-carmel',
                url: 'https://www.livelovesandiegohomes.com/communities/carmel-valley-real-estate',
                content: 'CARMEL VALLEY',
              },
              {
                id: 'communities-item-cardiff',
                url: 'https://www.livelovesandiegohomes.com/communities/cardiff-real-estate',
                content: 'CARDIFF',
              },
              {
                id: 'communities-item-clairemont',
                url: 'https://www.livelovesandiegohomes.com/communities/clairemont-real-estate',
                content: 'CLAIREMONT',
              },
              {
                id: 'communities-item-pacific',
                url: 'https://www.livelovesandiegohomes.com/communities/pacific-beach-real-estate',
                content: 'PACIFIC BEACH',
              },
              {
                id: 'communities-item-university',
                url: 'https://www.livelovesandiegohomes.com/communities/university-city-real-estate',
                content: 'UNIVERSITY CITY',
              },
              {
                id: 'communities-item-la-jolla',
                url: 'https://www.livelovesandiegohomes.com/communities/la-jolla-real-estate',
                content: 'LA JOLLA',
              },
            ],
          },
          {
            id: 'financing-item',
            url: 'https://www.livelovesandiegohomes.com/financing',
            content: 'FINANCING',
          },
          {
            id: 'testimonials-item',
            url: 'https://www.livelovesandiegohomes.com/testimonials',
            content: 'TESTIMONIALS',
          },
          {
            id: 'teams-item',
            content: 'TEAMS',
            menuItems: [
              {
                id: 'teams-item-sales',
                url: 'https://www.livelovesandiegohomes.com/sales-team',
                content: 'SALES TEAM',
              },
              {
                id: 'teams-item-back-office',
                url: 'https://www.livelovesandiegohomes.com/back-office-team',
                content: 'BACK OFFICE TEAM',
              },
              {
                id: 'teams-item-brokerage',
                url: 'https://www.livelovesandiegohomes.com/brokerage-agents',
                content: 'BROKERAGE AGENTS',
              },
            ],
          },
          {
            id: 'contact-us-item',
            url: 'https://www.livelovesandiegohomes.com/new-contact-us',
            content: 'CONTACT US',
          },
          {
            id: 'blog-item',
            url: 'https://www.livelovesandiegohomes.com/blog',
            content: 'BLOG',
          },
          {
            id: 'home-item',
            url: 'https://www.livelovesandiegohomes.com/',
            content: 'HOME',
            className: 'on-cres-desktop-special-item',
          },
        ],
      },
    },
  ],
  footers: [
    {
      id: 'on-cres-footer-first',
      display: true,
      className: 'on-cres-footer-section on-cres-footer-section-first',
      sectionClassName: 'on-cres-footer-section-container',
      columns: [
        {
          id: 'col-one',
          className: 'on-cres-footer-column on-cres-footer-column-one ',
          style: {},
          items: [
            {
              id: 'col-one-img',
              type: 'image',
              className: 'on-cres-footer-img',
              alt: 'img',
              url: 'https://images.squarespace-cdn.com/content/v1/5c53985ae4afe906c66b60a2/1557335877820-ZSVAD8T2WLGXYUWIG8NC/llsd+with+exp+transparent+DARKER.png?format=300w',
              style: { width: '274px' },
            },
            {
              id: 'col-one-heading-dre',
              type: 'heading',
              className: 'on-cres-footer-dre-text pt-1',
              data: 'DRE#01437116',
            },
            {
              id: 'col-one-heading-dre-two',
              type: 'heading',
              className: 'on-cres-footer-dre-text pt-0 pb-2',
              data: 'DRE#01878277',
            },
            {
              id: 'col-one-heading-one',
              type: 'heading',
              className: 'on-cres-footer-copyright-text pt-2',
              style: { fontWeight: 'bold' },
              data: '©eXp Realty of California, Inc',
            },
            {
              id: 'col-one-heading-two',
              type: 'heading',
              className: 'on-cres-footer-copyright-text',
              style: { fontWeight: 'bold' },
              data: '2022',
            },
            {
              id: 'col-one-heading-three',
              type: 'heading',
              className: 'on-cres-footer-copyright-text pt-0 pb-3',
              data: 'All Rights Reserved',
            },
          ],
        },
        {
          id: 'col-two',
          className: 'on-cres-footer-column ',
          style: { textAlign: 'left' },
          items: [
            {
              id: 'col-two-heading',
              type: 'heading',
              elementType: 'h1',
              className: 'on-cres-footer-heading',
              style: {},
              data: 'Popular Pages',
            },
            {
              id: 'col-two-menu',
              type: 'menu',
              className: 'on-cres-footer-menu',
              itemClassName: 'mb-0 on-cres-footer-menu-popular',
              style: { display: 'grid' },
              items: [
                {
                  id: 'col-two-item-one',
                  data: 'Buy',
                  url: 'https://search.livelovesandiegohomes.com/',
                },
                {
                  id: 'col-two-item-two',
                  data: 'Sell',
                  url: 'https://www.livelovesandiegohomes.com/home-valuation',
                },
                {
                  id: 'col-two-item-tradein',
                  data: 'Trade-In',
                  url: 'https://www.livelovesandiegohomes.com/trade-in',
                },
                {
                  id: 'col-two-item-three',
                  data: 'Communities',
                  url: 'https://www.livelovesandiegohomes.com/communities',
                },
                {
                  id: 'col-two-item-finance',
                  data: 'Financing',
                  url: 'https://www.livelovesandiegohomes.com/financing',
                },
                {
                  id: 'col-two-item-four',
                  data: 'Testimonials',
                  url: 'https://www.livelovesandiegohomes.com/testimonials',
                },
                {
                  id: 'col-two-item-five',
                  data: 'Teams',
                  url: 'https://www.livelovesandiegohomes.com/sales-team',
                },
                {
                  id: 'col-two-item-six',
                  data: 'Contact Us',
                  url: 'https://www.livelovesandiegohomes.com/new-contact-us',
                },

                {
                  id: 'col-two-item-eight',
                  data: 'Blog',
                  url: 'https://www.livelovesandiegohomes.com/blog',
                },
                {
                  id: 'col-two-item-nine',
                  data: 'Home',
                  url: 'https://www.livelovesandiegohomes.com/',
                },
              ],
            },
            {
              id: 'col-two-heading-two',
              type: 'heading',
              elementType: 'h1',
              className: 'on-cres-footer-heading pt-3 mt-3 pb-1',
              style: {},
              data: 'Office Hours',
            },
            {
              id: 'col-two-menu-two',
              type: 'menu',
              className: 'on-cres-footer-menu',
              itemClassName: 'on-cres-footer-menu-items mb-0',
              style: {},
              items: [
                {
                  id: 'col-two-item-twelve',
                  data: 'Monday - 8am - 6pm',
                },
                {
                  id: 'col-two-item-thirteen',
                  data: 'Tuesday - 8am - 6pm',
                },
                {
                  id: 'col-two-item-fourteen',
                  data: 'Wednesday - 8am - 6pm',
                },
                {
                  id: 'col-two-item-fifteen',
                  data: 'Thursday - 8am - 6pm',
                },
                {
                  id: 'col-two-item-sixteen',
                  data: 'Friday - 8am - 6pm',
                },
                {
                  id: 'col-two-item-seventeen',
                  data: 'Saturday - 9am - 5pm',
                },
                {
                  id: 'col-two-item-eighteen',
                  data: 'Sunday - 9am - 5pm',
                },
              ],
            },
          ],
        },
        {
          id: 'col-three',
          className: 'on-cres-footer-info  ',
          style: {},
          items: [
            {
              id: 'col-three-menu',
              type: 'menu',
              className: 'pt-xl-1',
              itemClassName: 'mb-0',
              style: {},
              items: [
                {
                  id: 'col-three-item-one',
                  data: 'Live. Love. San Diego Homes',
                  style: { lineHeight: '1.2' },
                  className: 'on-cres-footer-info-item',
                },
                {
                  id: 'col-three-item-two',
                  data: '619 South Vulcan Avenue, #215',
                  className: 'on-cres-footer-info-item',
                },
                {
                  id: 'col-three-item-three',
                  data: 'Encinitas, CA, 92024',
                  className: 'on-cres-footer-info-item',
                },
              ],
            },
            {
              id: 'col-three-menu-two',
              type: 'itemContent',
              className: 'mb-0 on-cres-footer-contact',
              style: {},
              items: [
                {
                  id: 'col-three-item-four',
                  content: 'Phone: ',
                },
                {
                  id: 'col-three-item-five',
                  content: '858-925-5900',
                  url: 'tel:858-925-5900',
                },
              ],
            },
            {
              id: 'col-three-menu-three',
              type: 'itemContent',
              className: 'mb-0 on-cres-footer-contact',
              style: {},
              items: [
                {
                  id: 'col-three-item-six',
                  content: 'Email: ',
                },
                {
                  id: 'col-three-item-seven',
                  content: 'Info@LiveLoveSDHomes.Com',
                  url: 'mailto:info@LiveLoveSDHomes.Com',
                },
              ],
            },
          ],
        },
        {
          id: 'col-four',
          className: 'on-cres-footer-column on-cres-footer-column-four ',
          style: {},
          items: [
            {
              id: 'col-one-img',
              type: 'image',
              className: 'on-cres-footer-img',
              alt: 'img',
              url: 'https://images.squarespace-cdn.com/content/v1/5c53985ae4afe906c66b60a2/1557335877820-ZSVAD8T2WLGXYUWIG8NC/llsd+with+exp+transparent+DARKER.png?format=300w',
              style: { width: '230px' },
            },
            {
              id: 'col-one-heading-dre',
              type: 'heading',
              className: 'on-cres-footer-dre-text pt-1',
              data: 'DRE#01437116',
            },
            {
              id: 'col-one-heading-dre-two',
              type: 'heading',
              className: 'on-cres-footer-dre-text pt-0 pb-3',
              data: 'DRE#01878277',
            },
            {
              id: 'col-one-heading-one',
              type: 'heading',
              className: 'on-cres-footer-copyright-text pt-2',
              style: { fontWeight: 'bold' },
              data: '©eXp Realty of California, Inc',
            },
            {
              id: 'col-one-heading-two',
              type: 'heading',
              className: 'on-cres-footer-copyright-text',
              style: { fontWeight: 'bold' },
              data: '2022',
            },
            {
              id: 'col-one-heading-three',
              type: 'heading',
              className: 'on-cres-footer-copyright-text pt-0 pb-3',
              data: 'All Rights Reserved',
            },
          ],
        },
      ],
    },
    {
      id: 'on-cres-footer-second',
      display: true,
      className: 'on-cres-footer-section on-cres-footer-section-last',
      sectionClassName: 'on-cres-footer-section-container',
      columns: [
        {
          id: 'footer-disclaimer',
          className: 'align-center on-cres-footer-privacy-col',
          style: {},
          items: [
            {
              id: 'footer-privacy-policy',
              type: 'heading',
              elementType: 'a',
              url: 'http://search.livelovesandiegohomes.com/privacy-policy',
              className: 'on-cres-footer-privacy-heading pt-5 pb-4',
              style: { fontSize: '13px' },
              data: 'PRIVACY POLICY',
            },
            {
              id: 'footer-privacy-text',
              type: 'heading',
              className: 'on-cres-footer-text pt-3',
              elementType: 'p',
              style: {},
              data: 'Copyright © 2022 California Regional MLS. All Rights Reserved. Information herein is deemed reliable but not guaranteed and is provided exclusively for consumers personal, non-commercial use, and may not be used for any purpose other than to identify prospective properties consumers may be interested in purchasing. Data last refreshed Tue Jun 07 2022 13:40:22 GMT+0200 (Central European Summer Time).',
            },
            {
              id: 'footer-dmca',
              type: 'heading',
              url: 'http://search.livelovesandiegohomes.com/idx-information',
              className: 'on-cres-footer-dmca',
              style: { fontSize: '16px', marginBottom: '10px' },
              data: 'DMCA Notice',
            },
            {
              id: 'footer-privacy-policy-two',
              type: 'heading',
              url: 'http://search.livelovesandiegohomes.com/privacy-policy',
              className: 'on-cres-footer-privacy-heading',
              style: {},
              data: 'Privacy Policy',
            },
          ],
        },
      ],
    },
  ],
  substitute: {},
  replace: {},
  siteData: {
    agency: 'Live. Love. San Diego Homes',
    agentDescription: 'Top agents in Encinitas, CA',
    agentAvatar: 'https://si-homelight.s3.amazonaws.com/sites/cres/agent.jpg',
    heroBackground: 'https://si-homelight.s3.amazonaws.com/sites/cres/hero-bg.jpg',
  },
};
